// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__2VhrA","resendInfoText":"OnGoingPaymentBox_resendInfoText__1Ogi0"};